import axios from "axios";
import {getAuth} from "firebase/auth";

const apiClient = axios.create({baseURL: process.env.VUE_APP_BACKEND_API_URL})
apiClient.interceptors.request.use(async (config) => {
    const currentUser = getAuth().currentUser
    if (currentUser != null) {
        config.headers = {
            ...(config.headers && {...config.headers}),
            authorization: `Bearer ${await currentUser.getIdToken()}`,
        }
    }
    return config
})

export default apiClient